import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Filter } from "lucide-react";

export default function FilterPopover({
    active = false,
    title = "Фільтр",
    hint = "",
    buttonTitle = "Фільтр",
    onClear,
    children,
}) {
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(() => (
        typeof window !== "undefined" ? window.innerWidth <= 768 : false
    ));
    const wrapRef = useRef(null);
    const popoverRef = useRef(null);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    useEffect(() => {
        if (!open) return undefined;
        const onDocDown = (event) => {
            const target = event.target;
            const inWrap = wrapRef.current && wrapRef.current.contains(target);
            const inPopover = popoverRef.current && popoverRef.current.contains(target);
            if (!inWrap && !inPopover) {
                setOpen(false);
            }
        };
        const onKeyDown = (event) => {
            if (event.key === "Escape") setOpen(false);
        };
        document.addEventListener("mousedown", onDocDown);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onDocDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [open]);

    const popover = open ? (
        <div
            className={`toolbar-filter-popover ${isMobile ? "toolbar-filter-popover--portal" : ""}`}
            role="dialog"
            aria-label={title}
            ref={popoverRef}
        >
            <div className="toolbar-filter-popover__title">{title}</div>
            {hint ? <p className="toolbar-filter-popover__hint">{hint}</p> : null}
            <div className="toolbar-filter-popover__body">{children}</div>
            <div className="toolbar-filter-popover__actions">
                {onClear ? (
                    <button
                        type="button"
                        className="add-btn cancel-btn"
                        onClick={onClear}
                        disabled={!active}
                    >
                        Очистити
                    </button>
                ) : null}
                <button
                    type="button"
                    className="add-btn"
                    onClick={() => setOpen(false)}
                >
                    Готово
                </button>
            </div>
        </div>
    ) : null;

    return (
        <div className={`toolbar-filter ${open ? "is-open" : ""}`} ref={wrapRef}>
            <button
                type="button"
                className={`add-btn refresh toolbar-icon-btn toolbar-filter-btn ${active ? "is-active" : ""} ${open ? "is-open" : ""}`}
                onClick={(e) => {
                    e.currentTarget.blur();
                    setOpen((value) => !value);
                }}
                onPointerUp={(e) => e.currentTarget.blur()}
                aria-expanded={open}
                aria-haspopup="dialog"
                title={buttonTitle}
                aria-label={buttonTitle}
            >
                <Filter size={16} />
                {active ? <span className="toolbar-filter-btn__dot" aria-hidden="true" /> : null}
            </button>
            {open
                ? (isMobile && typeof document !== "undefined"
                    ? createPortal(popover, document.body)
                    : popover)
                : null}
        </div>
    );
}

export function DateRangeFields({ from, to, onFromChange, onToChange, fromLabel = "Від", toLabel = "До" }) {
    return (
        <>
            <label className="toolbar-filter-field">
                <span>{fromLabel}</span>
                <input
                    type="date"
                    className="wr-date-input"
                    value={from}
                    onChange={(e) => onFromChange?.(e.target.value)}
                />
            </label>
            <label className="toolbar-filter-field">
                <span>{toLabel}</span>
                <input
                    type="date"
                    className="wr-date-input"
                    value={to}
                    onChange={(e) => onToChange?.(e.target.value)}
                />
            </label>
        </>
    );
}
